export default {
  //关于华翔
  companyProfile: {
    title: "企业概况",
  },
  //廉洁合规
  integrity: {
    p1: {
      title: "廉洁合规承诺",
      c1:
        "我们坚信诚信是取得业绩的基石，使我们能够提供优质产品和服务、与客户和供应商建立坦诚的关系， 并在竞争中不断取胜。宁波华翔的每位成员，都有责任遵守我们的行为准则：",
      l1: [
        "遵守一切适用的、指导我们公司全球业务经营活动的法律和法规；处理所有宁波华翔业务活动和业务关系时，要诚实、公正和可靠；",
        "避免任何公私利益冲突；",
        "培育公司内部人人机会平等的氛围；",
        "致力于保障工作安全，保护环境；",
        "建立并维护一个人人认同、推崇正直行为并身体力行的公司文化。",
      ],
      c2:
        "宁波华翔制定发布了《商业行为和道德准则规范》和《反舞弊管理制度》，确保每位成员在业务活动中都应遵守职业道德：",
      l2: [
        "避免不当支付；",
        "了解和遵守与国际贸易和国际金融交易有关的法律；",
        "防范洗钱；",
        "尊重隐私权；",
        "合法、公平及有效地发展与供应商的关系；",
        "按照最高道德标准与一切政府代表进行贸易；",
        "遵守竞争法律；",
        "避免利益冲突；",
        "在《商业行为和道德准则规范》规定的其他道德规范。",
      ],
    },
    p2: {
      title: "举报受理内容",
      c1:
        "宁波华翔受理来自公司内外部的有关反舞弊和利益冲突的举报信息，包括以下类型：",
      t1: "1. 舞弊行为",
      l1: [
        "1.1 收受或支付贿赂、回扣；",
        "1.2 利用公司资源、职位影响谋取个人利益；",
        "1.3 将正常情况下可以使公司获利的交易事项转移给其他单位，谋取自身利益；",
        "1.4 非法使用公司资产，贪污、侵占、挪用、盗窃公司资产；",
        "1.5 未经授权代表公司与其他单位进行业务活动，使公司为虚假的交易事项支付款项或承担债务；",
        "1.6 故意隐瞒、错报交易事项；",
        "1.7 伪造、变造会计记录或凭证，在财务会计报告和信息披露等方面出现虚假记载、误导性陈述或者重大遗漏；",
        "1.8 偷逃税款；",
        "1.9 泄露公司的商业秘密或技术秘密；",
        "1.10 从事违法违规的经济活动；",
        "1.11 董事、监事、总经理及其他高级管理人员玩忽职守、滥用职权。",
      ],
      t2: "2. 高管或员工（及其近亲属）的以下利益冲突行为",
      l2: [
        "2.1 直接或间接控制与宁波华翔进行交易的企业或者竞争企业；",
        "2.2 是交易企业的代表，或者在交易中存在利益；",
        "2.3 从交易企业或者竞争企业那里接受其价值超过一般礼物价值的商品，现金或者证券作为礼物，或者接受贷款和过于奢华的款待等；",
        "2.4 未经公司同意，擅自向任何其他公司提供重大的管理，咨询以及其他方面服务（包括担任董事）；",
        "2.5 影响交易企业或者竞争企业与第三方的交易（例如胁迫宁波华翔的供货商从某个个人所有的企业采购）；",
        "2.6 与宁波华翔形成竞争。",
      ],
    },
    p3: {
      title: "举报途径",
      c1:
        "宁波华翔举报通道并向全社会公开举报渠道，接受来自公司内外部的关于反舞弊和利益冲突的举报信息。\n\n",
      l1: [
        "举报电话：138 1803 7523",
        "举报邮箱：audit@nbhx.com",
        "邮寄地址：上海市浦东新区世纪大道1168号东方金融广场  宁波华翔电子股份有限公司内审部",
      ],
      c2:'举报须知',
      l2:[
          '举报人可以选择实名举报或匿名举报。我们将对举报人的身份信息严格保密，不允许对举报人的任何形式的报复，一旦发现报复行为，将对相关人员作严肃处理。',
          '举报人提交的信息需尽量详实、具体，能提供实质性证据或指向明确的调查方向。',
          '举报人对举报内容的真实性负责。对于捏造事实、故意诽谤的行为，一经查实，华翔保留对举报者采取法律手段或内部惩处的权利。'
        ]
    },
  },

  //全球布局
  中国: "中国",
  全球: "全球",
  全球布局: "全球布局",
  中国布局: "中国布局",
  desclist: [
    [
      {
        num: 0,
        unit: "亿元",
        title: "2018年营业额",
        picture: require("../../assets/img/about/1.png"),
      },
      {
        num: 0,
        unit: "家",
        title: "生产基地",
        picture: require("../../assets/img/about/2.png"),
      },
      {
        num: 0,
        unit: "人",
        title: "员工人数",
        picture: require("../../assets/img/about/3.png"),
      },
      {
        num: 0,
        unit: "家",
        title: "<div>区域研发中心</div><small>中国/美国/德国</small>",
        picture: require("../../assets/img/about/4.png"),
      },
    ],
    [
      {
        num: 0,
        unit: "亿元",
        title: "2018年营业额",
        picture: require("../../assets/img/about/1.png"),
      },
      {
        num: 0,
        unit: "家",
        title: "生产基地",
        picture: require("../../assets/img/about/2.png"),
      },
      {
        num: 0,
        unit: "人",
        title: "员工人数",
        picture: require("../../assets/img/about/3.png"),
      },
      {
        num: 0,
        unit: "家",
        title: "<div>区域研发中心</div>",
        picture: require("../../assets/img/about/4.png"),
      },
    ],
  ],
  enterpriselist: [
    {
      title: "亚洲",
      list: [
        "中国（50多家生产基地，1个区域研发中心）",
        "菲律宾诗兰姆汽车零部件有限公司",
        "印度尼西亚诗兰姆汽车零部件有限公司",
        "越南诗兰姆汽车零部件有限公司",
        "新加坡诗兰姆汽车零部件有限公司",
      ],
    },
    {
      title: "欧洲",
      list: [
        "NBHX TRIM GmbH",
        "HIB TRIM Part Solutions GmbH",
        "NBHX Trim Management Services GmbH",
        "Northern Automotive Systems Limited",
        "NBHX TRIM CZ s.r.o",
        "SC Rolem SRL.RO",
      ],
    },
    {
      title: "北美洲",
      list: [
        "NBHX TRIM USA Corporation",
        "Northern Engraving Corporation ",
        "NBHX TRIM Mexico Sde R.L de C.V.MEX",
      ],
    },
  ],
  markerTitles: [
    {
      x: "887",
      y: "397",
      title:
        "成都华翔汽车顶棚系统有限公司\n成都井上华翔汽车零部件有限公司\n成都华翔轿车消声器有限责任公司",
    },
    {
      x: "903",
      y: "403",
      title: "绵阳诗兰姆汽车零部件有限公司",
    },
    {
      x: "971",
      y: "383",
      title: "重庆胜维德赫华翔汽车零部件有限公司",
    },
    {
      x: "1058",
      y: "256",
      title: "柳州井上华翔汽车零部件有限公司",
    },
    {
      x: "1102",
      y: "355",
      title: "长沙井上华翔汽车零部件有限公司",
    },
    {
      x: "1150",
      y: "414",
      title: "武汉井上华翔汽车零部件有限公司\n武汉诗兰姆汽车零部件有限公司",
    },
    {
      x: "1150",
      y: "231",
      title:
        "佛山华翔汽车顶棚系统有限公司\n佛山井上华翔汽车零部件有限公司\n佛山华翔汽车金属零部件有限公司",
    },
    {
      x: "1163",
      y: "595",
      title:
        "天津华翔汽车顶棚系统有限公司\n天津井上华翔汽车零部件有限公司\n天津诗兰姆汽车零部件有限公司\n天津华翔汽车金属零部件有限公司\n天津胜维德赫华翔汽车零部件有限公司",
    },
    {
      x: "1176",
      y: "364",
      title: "南昌华翔汽车零部件有限公司\n南昌华翔汽车内外饰件有限公司",
    },
    {
      x: "1176",
      y: "249",
      title: "东莞华翔汽车车门系统有限公司\n东莞井上建上汽车零部件有限公司",
    },
    {
      x: "1160",
      y: "209",
      title: "中山诗兰姆汽车零部件有限公司",
    },
    {
      x: "1217",
      y: "559",
      title: "烟台诗兰姆汽车零部件有限公司\n烟台艾倍思井华汽车零部件有限公司",
    },
    {
      x: "1236",
      y: "541",
      title: "青岛华翔汽车顶棚系统有限公司\n青岛华翔汽车金属零部件有限公司",
    },
    {
      x: "1242",
      y: "452",
      title: "扬州华翔汽车车门系统有限公司",
    },
    {
      x: "1258",
      y: "448",
      title: "无锡井上华光汽车零部件有限公司",
    },
    {
      x: "1242",
      y: "626",
      title: "沈阳华翔汽车零部件有限公司\n沈阳艾倍思井华汽车零部件有限公司",
    },
    {
      x: "1270",
      y: "440",
      title: "苏州诗兰姆汽车零部件有限公司",
    },
    {
      x: "1262",
      y: "679",
      title: "公主岭井上华翔汽车零部件有限公司\n公主岭华翔汽车顶棚系统有限公司",
    },
    {
      x: "1295",
      y: "441",
      title: "上海智轩汽车附件有限公司\n上海井上华翔汽车零部件有限公司",
    },
    {
      x: "1301",
      y: "403",
      title:
        "宁波华翔汽车车门系统有限公司\n宁波井上华翔汽车零部件有限公司\n宁波华翔哈尔巴克汽车电子有限公司\n宁波诗兰姆汽车零部件有限公司\n宁波华翔特雷姆汽车饰件 有限公司\n宁波胜维德赫华翔汽车零部件有限公司\n宁波艾倍思井华汽车零部件有限公司\n宁波华翔汽车饰件有限公司\n宁波米勒模具制造有限公司\n宁波劳伦斯汽车内饰件有限公司\n宁波华翔表面处理技术有限公司\n宁波华翔汽车新材料科技有限公司",
    },
    {
      x: "1288",
      y: "689",
      title: "长春诗兰姆汽车零部件有限公司\n长春华翔轿车消声器有限责任公司",
    },
    {
      x: "1100",
      y: "475",
      title: "郑州井上华翔汽车零部件有限公司",
    },
  ],
  markerTitle: [
    "Northern Automotive Systems Limited",
    "NBHX TRIM GmbH\nHIB TRIM Part Solutions GmbH\nNBHX Trim Management Services GmbH",
    "NBHX TRIM CZ s.r.o",
    "SC Rolem SRL.RO",
    "越南诗兰姆汽车零部件有限公司",
    "新加坡诗兰姆汽车零部件有限公司",
    "印度尼西亚诗兰姆汽车零部件有限公司",
    "菲律宾诗兰姆汽车零部件有限公司",
    "NBHX TRIM Mexico Sde R.L de C.V.MEX",
    "Northern Engraving Corporation ",
    "NBHX TRIM USA Corporation",
    "中国（50多家生产基地，1个区域研发中心）",
  ],
  enterpriseChinaList: [
    {
      title: "华东",
      list: [
        "宁波华翔汽车车门系统有限公司",
        "宁波井上华翔汽车零部件有限公司",
        "宁波华翔哈尔巴克汽车电子有限公司",
        "宁波诗兰姆汽车零部件有限公司",
        "宁波华翔特雷姆汽车饰件 有限公司",
        "宁波胜维德赫华翔汽车零部件有限公司",
        "宁波艾倍思井华汽车零部件有限公司",
        "宁波华翔汽车饰件有限公司",
        "宁波米勒模具制造有限公司",
        "宁波劳伦斯汽车内饰件有限公司",
        "宁波华翔表面处理技术有限公司",
        "宁波华翔汽车新材料科技有限公司",
        "上海智轩汽车附件有限公司",
        "上海井上华翔汽车零部件有限公司",
        "青岛华翔汽车顶棚系统有限公司",
        "青岛华翔汽车金属零部件有限公司",
        "扬州华翔汽车车门系统有限公司",
        "苏州诗兰姆汽车零部件有限公司",
        "无锡井上华光汽车零部件有限公司",
        "烟台诗兰姆汽车零部件有限公司",
        "烟台艾倍思井华汽车零部件有限公司",
      ],
    },
    {
      title: "华中",
      list: [
        "武汉井上华翔汽车零部件有限公司",
        "武汉诗兰姆汽车零部件有限公司",
        "长沙井上华翔汽车零部件有限公司",
        "郑州井上华翔汽车零部件有限公司",
        "南昌华翔汽车零部件有限公司",
        "南昌华翔汽车内外饰件有限公司",
      ],
    },
    {
      title: "华南",
      list: [
        "东莞华翔汽车车门系统有限公司",
        "东莞井上建上汽车零部件有限公司",
        "佛山华翔汽车顶棚系统有限公司",
        "佛山井上华翔汽车零部件有限公司",
        "佛山华翔汽车金属零部件有限公司",
        "中山诗兰姆汽车零部件有限公司",
        "柳州井上华翔汽车零部件有限公司",
      ],
    },
    {
      title: "华北",
      list: [
        "天津华翔汽车顶棚系统有限公司",
        "天津井上华翔汽车零部件有限公司",
        "天津诗兰姆汽车零部件有限公司",
        "天津华翔汽车金属零部件有限公司",
        "天津胜维德赫华翔汽车零部件有限公司",
      ],
    },
    {
      title: "东北",
      list: [
        "长春诗兰姆汽车零部件有限公司",
        "长春华翔轿车消声器有限责任公司",
        "公主岭井上华翔汽车零部件有限公司",
        "公主岭华翔汽车顶棚系统有限公司",
        "沈阳华翔汽车零部件有限公司",
        "沈阳艾倍思井华汽车零部件有限公司",
      ],
    },
    {
      title: "西南",
      list: [
        "成都华翔汽车顶棚系统有限公司",
        "成都井上华翔汽车零部件有限公司",
        "成都华翔轿车消声器有限责任公司",
        "绵阳诗兰姆汽车零部件有限公司",
        "重庆胜维德赫华翔汽车零部件有限公司",
      ],
    },
  ],
  //合作伙伴
  partnershipList: [
    {
      name: "江铃集团",
      desc:
        "江铃汽车集团有限公司是我国汽车整车出口基地和轻型柴油商用车主要出口商之一，拥有六大整车制造基地，整车产品涵盖多种车型，并具备六大总成自主研发制造能力。",
      logo: require("../../assets/img/about/partnership/1.jpg"),
      url: "https://www.jmcg.com.cn/",
    },
    {
      name: "富奥汽车",
      desc:
        "富奥汽车零部件股份有限公司主要生产环境控制系统、底盘系统、转向及传动系统、安全系统、发动机附件系统等汽车零部件产品，主要为一汽集团、上汽大众、上汽通用、东风神龙等多家整车厂、主机厂配套；产品远销美国、法国、意大利、韩国、日本和中东地区等十几个国家。",
      logo: require("../../assets/img/about/partnership/2.jpg"),
      url: "http://www.fawer.com.cn/zh-cn/",
    },
    {
      name: "长春一汽富晟",
      desc:
        "长春一汽富晟集团有限公司由一汽集团参股，为客户配套制动器模块、转向模块、电子电器模块、内外饰模块、发动机附件模块产品的研发、生产和准时化供货任务，主要为一汽集团旗下品牌配套。并先后与全球多家行业内知名公司成立合资公司。",
      logo: require("../../assets/img/about/partnership/3.jpg"),
      url: "http://www.fawsn.com.cn/",
    },
    {
      name: "胜维德赫(SMR)",
      desc:
        "Samvardhana Motherson Reflectec是世界上知名的乘用车后视镜制造商之一，也是开发汽车应用智能摄像头技术的先驱。SMR也是全球知名的汽车行业供应商Samvardhana Motherson Group(SMG)的成员。",
      logo: require("../../assets/img/about/partnership/4.jpg"),
      url: "http://www.smr-automotive.com/en",
    },
    {
      name: "诗兰姆(SCHLEMMER)",
      desc:
        "Schlemmer Holding GmbH专注于开发和生产高度专业化的塑料件和金属件。凭借60年的线束保护经验，公司已成为全球知名的供应商之一。",
      logo: require("../../assets/img/about/partnership/5.jpg"),
      url: "http://www.schlemmer.com.cn/",
    },
    {
      name: "井上集团(INOAC)",
      desc:
        "INOAC Corporation成立于1926年，产品包括由聚氨酯、橡胶、塑料和复合材料等制成的汽车内外饰零部件、内饰产品各种工业材料、化妆品容器和住宅材料等。",
      logo: require("../../assets/img/about/partnership/6.jpg"),
      url: "https://www.inoac.co.jp/",
    },
    {
      name: "佛吉亚(FAURECIA)",
      desc:
        "FAURECIA是法国标致雪铁龙集团旗下汽车零部件企业，致力于为汽车制造厂商提供高质量的创新产品、技术解决方案和服务，在汽车座椅、绿动智行系统和汽车内饰三大业务领域居业界先进地位。",
      logo: require("../../assets/img/about/partnership/7.jpg"),
      url: "https://www.faurecia.cn/",
    },
    {
      name: "宁波福尔达",
      desc:
        "宁波福尔达智能科技有限公司致力于为一汽大众、上汽大众、上汽通用、北京奔驰等整车厂进行同步设计、开发、制造各款中高端乘用车智能电子集成控制系统、照明系统、关键功能件等。研发能力较强，拥有多项国家专利。",
      logo: require("../../assets/img/about/partnership/8.jpg"),
      url: "http://www.fuerda-china.com/",
    },
    {
      name: "哈尔巴克(HELBAKO)",
      desc:
        "Helbako GmbH是一家总部位于德国的全球汽车供应商，成立于1977年，主要从事轿车电子类产品的研发和生产，产品包括：电子燃油泵控制模块、前大灯光束范围调节、顶蓬控制系统等，主要客户为宝马、奔驰、大众、奥迪和保时捷等。",
      logo: require("../../assets/img/about/partnership/9.jpg"),
      url: "https://www.helbako.de/startseite/",
    },
    {
      name: "中集车辆",
      desc:
        "中集车辆(集团)股份有限公司是中国国际海运集装箱（集团）股份有限公司的子公司，是目前国内规模较大的专用汽车企业集团之一。主要从事半挂车及专用车上装制造及销售。",
      logo: require("../../assets/img/about/partnership/10.jpg"),
      url: "http://www.cimcvehiclesgroup.com/",
    },
    {
      name: "ABC Technologies",
      desc:
        "ABC Technologies是加拿大一家成立于1974年的世界知名的汽车系统和零部件制造商。公司拥有数百项材料技术、产品和加工系统专利，产品创新享誉国际。",
      logo: require("../../assets/img/about/partnership/11.jpg"),
      url: "http://www.abcgroupinc.com",
    },
    {
      name: "无锡华光",
      desc:
        "无锡华光汽车部件集团有限公司始创于1990年，生产辊轧和冲压类、总成装配类以及注塑和挤出类产品，主要为一汽大众、上汽大众、神龙公司等多家整车厂、主机厂配套。",
      logo: require("../../assets/img/about/partnership/12.jpg"),
      url: "http://www.huaguang-group.com/",
    },
  ],
  //客户
  navlist: ["海外客户", "合资品牌", "自主品牌", "造车新势力"],
  //荣誉
  awardList: [
    [
      {
        poster: require("../../assets/img/about/award/2019-1.jpg"),
        year: "2019年",
        title: "汽车零部件供应链优秀企业",
        content:
          "宁波华翔电子股份有限公司荣获中国物流与采购联合会颁发的\n“2019年度汽车零部件供应链优秀企业”奖",
      },
    ],
    [
      {
        poster: require("../../assets/img/about/award/b-1.jpg"),
        year: "2018年",
        title: "优秀开发供应商",
        content:
          "宁波华翔特雷姆汽车饰件有限公司荣获一汽-大众颁发的\n“2018年度优秀开发供应商”奖",
      },
      {
        poster: require("../../assets/img/about/award/b-2.jpg"),
        year: "2018年",
        title: "国家高新技术企业",
        content:
          "南昌华翔汽车零部件有限公司荣获江西省税务局、江西省科学技术厅、财政厅等单位联合颁发的\n“国家高新技术企业”奖",
      },
      {
        poster: require("../../assets/img/about/award/b-5.jpg"),
        year: "2018年",
        title: "Q1 奖",
        content: "重庆胜维德赫华翔汽车零部件有限公司荣获长安福特汽车的\n“Q1”奖",
      },
      {
        poster: require("../../assets/img/about/award/b-3.jpg"),
        year: "2018年",
        title: "Q1 奖",
        content: "宁波胜维德赫华翔汽车镜有限公司荣获长安福特颁发的\n“Q1”奖",
      },
      {
        poster: require("../../assets/img/about/award/b-4.jpg"),
        year: "2018年",
        title: "JLRQ 优秀供应商奖",
        content:
          "宁波胜维德赫华翔汽车镜有限公司荣获捷豹路虎\n“JLRQ 优秀供应商”奖",
      },
      {
        poster: require("../../assets/img/about/award/b-6.jpg"),
        year: "2018年",
        title: "优秀供应商奖",
        content:
          "宁波井上华翔汽车零部件有限公司荣获华晨中华汽车颁发的\n“2018优秀供应商”奖",
      },
      {
        poster: require("../../assets/img/about/award/b-7.jpg"),
        year: "2018年",
        title: "总经理质量奖",
        content:
          "宁波诗兰姆汽车零部件有限公司荣获中国重汽颁发的\n“总经理质量奖”",
      },
      {
        poster: require("../../assets/img/about/award/b-8.jpg"),
        year: "2018年",
        title: "浙江名牌产品证书",
        content:
          "宁波华翔电子股份有限公司荣获浙江省质量技术监督局颁发的\n“浙江名牌产品证书”奖”",
      },
    ],
    [
      {
        poster: require("../../assets/img/about/award/a-1.jpg"),
        year: "2017年",
        title: "20年志合金石奖",
        content:
          "长春华翔轿车消声器有限责任公司荣获一汽轿车颁发的 \n“20年志合金石奖”",
      },
      {
        poster: require("../../assets/img/about/award/a-2.jpg"),
        year: "2017年",
        title: "特殊贡献奖",
        content:
          "长春华翔轿车消声器有限责任公司荣获一汽轿车颁发的 \n“特殊贡献奖”",
      },
    ],
    [
      {
        poster: require("../../assets/img/about/award/1.jpg"),
        year: "2016年",
        title: "优秀供应商",
        content:
          "宁波华翔电子股份有限公司荣获上汽大众颁发的\n“2016年度优秀供应商”奖",
      },
      {
        poster: require("../../assets/img/about/award/2.jpg"),
        year: "2016年",
        title: "品质达成奖",
        content:
          "长春华翔轿车消声器有限责任公司荣获天津一汽丰田汽车有限公司颁发的\n“品质达成奖”",
      },
      {
        poster: require("../../assets/img/about/award/3.jpg"),
        year: "2016年",
        title: "A级供应商奖",
        content:
          "长春华翔轿车消声器有限责任公司荣获一汽-大众颁发的 \n“A级供应商奖”",
      },
    ],
  ],
  合作共赢: "合作共赢",
  contact: {
    c1: "地址：中国上海市浦东新区世纪大道1168号A栋6楼",
    c2: "邮编：200122",
    c3: "电话：+86 21 68949998",
    text: "各子公司联系方式",
    t1:
      '我们致力于为客户提供优质的产品和服务。为了确保这一目标的实现，我们坚持与合格高效的供应商合作。我们一直在寻找新的合作伙伴以保持高品质和市场领先地位，如您有意与我们共谋发展，请填妥附件供方调查表，发送邮件至<a href="mailto:supplierinfo@nbhx.com.cn">supplierinfo@nbhx.com.cn</a>。',
    t2: "供方调查表",
  },
};
